import { render, staticRenderFns } from "./InaccessiblePadsInformModal.vue?vue&type=template&id=213344d2&scoped=true"
import script from "./InaccessiblePadsInformModal.vue?vue&type=script&lang=js"
export * from "./InaccessiblePadsInformModal.vue?vue&type=script&lang=js"
import style0 from "./InaccessiblePadsInformModal.vue?vue&type=style&index=0&id=213344d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213344d2",
  null
  
)

export default component.exports